jQuery(function ($) {
    function setButtonState($btn, watching) {
        const onLabel = ($btn.attr('data-label-on') || 'Watching').toString();
        const offLabel = ($btn.attr('data-label-off') || 'Watch price').toString();
        const label = watching ? onLabel : offLabel;

        // Button contains icon SVG; replace only the text node by rebuilding HTML.
        const hasIcon = $btn.find('svg').length > 0;
        if (hasIcon) {
            const $icon = $btn.find('svg').first().clone();
            $btn.empty().text(label + ' ');
            $btn.append($icon);
        } else {
            $btn.text(label);
        }

        $btn.toggleClass('is-watching', !!watching);
        $btn.attr('aria-pressed', watching ? 'true' : 'false');
        $btn.attr('aria-label', label);
        $btn.attr('title', label);
    }

    function initButton($btn) {
        const carId = parseInt($btn.attr('data-car-id') || '0', 10);
        const statusUrl = ($btn.attr('data-status-url') || '').toString();
        if (!carId || !statusUrl) {
            return;
        }

        $.ajax({
            url: statusUrl,
            type: 'GET',
            dataType: 'json',
            cache: false,
            data: { car_id: carId },
            success: function (resp) {
                if (resp && resp.success === true) {
                    setButtonState($btn, !!resp.watching);
                }
            },
            error: function () {
                // Not logged in or endpoint not available: keep default state
            }
        });
    }

    function toggleWatch($btn) {
        const carId = parseInt($btn.attr('data-car-id') || '0', 10);
        const toggleUrl = ($btn.attr('data-toggle-url') || '').toString();
        const loginUrl = ($btn.attr('data-login-url') || '/profile/login').toString();
        if (!carId || !toggleUrl) return;

        if (typeof csrfSafeAjaxPost !== 'function') {
            window.location.href = loginUrl;
            return;
        }

        $btn.prop('disabled', true);
        csrfSafeAjaxPost(
            toggleUrl,
            { car_id: carId },
            function (resp) {
                $btn.prop('disabled', false);
                if (!resp) return;
                if (resp.success === true) {
                    setButtonState($btn, !!resp.watching);
                    return;
                }
            },
            function (xhr) {
                $btn.prop('disabled', false);
                if (xhr && xhr.status === 401) {
                    window.location.href = loginUrl;
                }
            }
        );
    }

    // Init all watch buttons
    $('.price-watch-toggle').each(function () {
        initButton($(this));
    });

    // Toggle
    $(document).on('click', '.price-watch-toggle', function (e) {
        e.preventDefault();
        toggleWatch($(this));
    });
});


